// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-card-fields-container-KVTkl {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-top: 48px;
  padding-bottom: 24px;
}

.product-card-fields-transition-abQn2 {
  color: transparent;
}

.product-card-fields-transition-abQn2 > div > label {
  color: transparent;
  background-color: var(--color-neutral-100);
  width: fit-content;
  animation: product-card-fields-pulse-xqGKv 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  border-radius: var(--radius-lg);
}

.product-card-fields-transition-abQn2 > div > :not(label) * {
  opacity: 0;
}

.product-card-fields-transition-abQn2 > div > :not(label) {
  border-color: transparent;
  background-color: var(--color-neutral-100);
  animation: product-card-fields-pulse-xqGKv 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  border-radius: var(--radius-lg);
}

@keyframes product-card-fields-pulse-xqGKv {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/product-card/product-card-fields/product-card-fields.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,mFAAyD;EACzD,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,mFAAyD;EACzD,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  margin-top: 48px;\n  padding-bottom: 24px;\n}\n\n.transition {\n  color: transparent;\n}\n\n.transition > div > label {\n  color: transparent;\n  background-color: var(--color-neutral-100);\n  width: fit-content;\n  animation: pulse 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  border-radius: var(--radius-lg);\n}\n\n.transition > div > :not(label) * {\n  opacity: 0;\n}\n\n.transition > div > :not(label) {\n  border-color: transparent;\n  background-color: var(--color-neutral-100);\n  animation: pulse 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  border-radius: var(--radius-lg);\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `product-card-fields-container-KVTkl`,
	"transition": `product-card-fields-transition-abQn2`,
	"pulse": `product-card-fields-pulse-xqGKv`
};
export default ___CSS_LOADER_EXPORT___;
